import React from 'react'
import styled from 'styled-components'
import knobImg from '../static/images/icons/knob.png'
import knobLvlImg from '../static/images/icons/knob_level.png'
import arrowImg from '../static/images/icons/index_arrow.png'
import { media } from '../styles/vars'

const KnobContainer = styled.div`
width:80px;
height:80px;
background-size:contain;
background-image:url(${knobLvlImg});
background-repeat:no-repeat;
position:relative;

&:first-child > div {
    transform:rotate(-20deg);
}
&:nth-child(2) > div {
    transform:${props => props.active ? 'rotate(273deg)' : 'none'};
}
&:last-child > div {
    transform:rotate(70deg);
}

${media.desktop`
width:110px;
height:110px;
`}
`
const BigKnobContainer = styled(KnobContainer) `
width:100px;
height:100px;
&:after{
    content:'';
    position:absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background-image:url(${arrowImg});
    background-repeat:no-repeat;
    background-position:center;
    background-size:50%;
    opacity:${props => props.active ? '.4' : '1'};
    transition:opacity .4s;
}

${media.desktop`
width:150px;
height:150px;
cursor:pointer;
`}
`
const KnobButton = styled.div`
background-size:contain;
background-repeat:no-repeat;
background-image:url(${knobImg});
width:80%;
height:80%;
position:absolute;
top:0;
left:0;
bottom:0;
right:0;
margin:auto;
transition:transform .7s;
will-change:transform;
`

const Knob = (props) => {
    if (props.big) {
        return (
            <BigKnobContainer
                active={props.active}
                onClick={props.onKnobClick}
            >
                <KnobButton />
            </BigKnobContainer  >
        )
    }
    return (
        <KnobContainer>
            <KnobButton />
        </KnobContainer>
    )
}


export default Knob;


// WEBPACK FOOTER //
// ./src/components/Knob.jsx